module.exports = __webpack_public_path__ + "static/other/vending_machine.83af2b84.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/maps/vending_machine.json
// module id = 2578
// module chunks = 0